import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const Container = styled(FlexContainer)<{ $isMandatory: boolean }>`
  background-color: ${({ theme, $isMandatory }) =>
    $isMandatory
      ? theme.system.background.fds_sys_color_background_supersoft
      : theme.system.background.fds_sys_color_background_success};
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
`;

export const AmountContainer = styled(FlexContainer)`
  svg {
    width: ${({ theme }) => theme.reference.dimension_32};
    height: ${({ theme }) => theme.reference.dimension_32};
  }
`;
